
import React from 'react';
import { Box, Typography, Alert, Grid, Card, CardContent, Chip, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import { useTheme } from '@mui/material';
import { capitalizeFirstLetter, getOcpiRole, getOcpiVersions } from 'src/utils/helper';
import { checklist } from '../constants/ocpi.constant';

const ReviewStep = ({ values, companies, roles, versions }) => {
  const theme = useTheme();
  const companyName = companies?.find(c => c.id === values.companyId)?.name || '';
  const endpointsCount = Array.isArray(values.endpoints) ? values.endpoints.length : 0;

  return (
    <Box>
      {/* Final Review Card */}
      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h5" fontWeight={700} sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1, fontFamily: 'inherit' }}>
            <Icon icon="mdi:check-circle-outline" color={theme.palette.primary.main} width={26} /> Final Review & Activation
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1, fontFamily: 'inherit' }}>
            Configuration Summary
          </Typography>
          <Box sx={{ background: '#fafbfc', borderRadius: 2, p: 2, mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Stack spacing={1}>
                  <Typography variant="body1" sx={{ fontFamily: 'inherit' }}><b>Partner:</b> {companyName || values.partnerName}</Typography>
                  <Typography variant="body1" sx={{ fontFamily: 'inherit' }}><b>Party ID:</b> {values.partyId}</Typography>
                  <Typography variant="body1" sx={{ fontFamily: 'inherit' }}><b>Role:</b> {getOcpiRole(roles, values.ocpiRole)}</Typography>
                  <Typography variant="body1" sx={{ fontFamily: 'inherit' }}><b>Version:</b> {getOcpiVersions(versions, values.ocpiVersion)}</Typography>
                  <Typography variant="body1" sx={{ fontFamily: 'inherit' }}><b>Base URL:</b> {values.baseUrl}</Typography>
                  <Typography variant="body1" sx={{ fontFamily: 'inherit' }}><b>Endpoints:</b> {values.endpointsCount} configured</Typography>
                  <Typography variant="body1" sx={{ fontFamily: 'inherit' }}><b>Sync Mode:</b> {capitalizeFirstLetter(values.syncMode)}</Typography>
                  <Typography variant="body1" sx={{ fontFamily: 'inherit' }}><b>Security:</b> Token auth only</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>
          <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2, mb: 1, fontFamily: 'inherit' }}>
            Go-Live Checklist
          </Typography>
          <Grid container spacing={1}>
            {checklist.map((item, idx) => (
              <Grid item xs={12} sm={6} md={4} key={item.label}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
                  <Icon icon="mdi:check-circle-outline" color={theme.palette.primary.main} width={22} />
                  <Typography variant="body2" sx={{ fontFamily: 'inherit' }}>{item.label}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      {/* Health Monitoring Card */}
      {/* <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h5" fontWeight={700} sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1, fontFamily: 'inherit' }}>
            <Icon icon="mdi:waveform" width={24} /> Partner Health Monitoring
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontFamily: 'inherit' }}>
            Real-time performance metrics for {values.partyId || 'partner'}
          </Typography>
          <Grid container spacing={2}>
            {health.map((stat, idx) => (
              <Grid item xs={12} sm={6} key={stat.label}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: '#f7fafc', borderRadius: 2, p: 2, mb: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Icon icon={stat.icon} color={theme.palette.primary.main} width={20} />
                    <Typography variant="body1" fontWeight={600} sx={{ fontFamily: 'inherit' }}>{stat.label}</Typography>
                  </Box>
                  <Box sx={{ textAlign: 'right' }}>
                    <Typography variant="body1" fontWeight={700} color="primary.main" sx={{ fontFamily: 'inherit' }}>{stat.value}</Typography>
                    {stat.sub && (
                      <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'inherit' }}>{stat.sub}</Typography>
                    )}
                  </Box>
                </Box>
              </Grid>
            ))}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: { xs: 'flex-start', md: 'space-between' }, mt: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: { xs: 1, md: 0 } }}>
                  <Icon icon="mdi:clock-outline" width={18} style={{ verticalAlign: 'middle' }} />
                  <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'inherit' }}>Last Health Check</Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ ml: 1, fontFamily: 'inherit' }}>{lastCheck}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Icon icon="mdi:flash" color="primary.main" width={22} />
                  <Chip label={healthScore} color="primary" sx={{ fontWeight: 600, fontSize: 16, px: 2, background: 'primary.lighter', fontFamily: 'inherit' }} />
                  <Typography variant="body2" color="text.secondary" sx={{ ml: 1, fontFamily: 'inherit' }}>Overall Health Score</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card> */}
    </Box>
  );
};

export default ReviewStep;
